<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            <span v-if="edit">Label #{{ this.form.Labelid }}</span>
            <span v-else-if="form.labeltype === 'K'">Ny Label, Kunst/Nett</span>
            <span v-else-if="form.labeltype === 'V'">Ny Label, Vin</span>
          </h3>
        </div>
      </div>

      <div class="modal-window-body">
        <div class="cell large-12">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Navn" name="Navn" v-model.trim="form.Navn" maxlength="100" required v-validate="'required|max:100'"/>
              <TheTextInput containerClassName="cell large-6" label="Engelsk" name="Engelsk" v-model.trim="form.Engelsk" maxlength="100" v-validate="'max:100'"/>

              <TheSelectInput containerClassName="cell large-6" label="Label type" name="labeltype" required v-validate="'required'" v-model.trim="form.labeltype" :items="labelTypeOptions"/>

              <TheSelectInput
                v-show="form.labeltype === 'K'"
                containerClassName="cell large-6"
                label="Kategori"
                name="Kategori"
                v-model.trim="form.Kategori"
                :items="kategoriOptions"
                data-vv-validate-on="input"
              />

              <div class="cell large-6" v-show="form.labeltype === 'V'">
                <label>Parent</label>
                <treeselect v-model="form.Parent" :sort-value-by="'INDEX'" :multiple="false" :default-expand-level="0" :options="parentOptionsTree"/>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable && !deleting" href="javascript:;" @click="handleSubmit()" class="button primary submit large">Lagre</a>
            <a v-else-if="$store.getters.isFormProcessing && !deleting" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-else-if="$store.getters.isFormLoading || deleting" href="javascript:;" class="button primary submit large" disabled>Lagre</a>

            <!-- <template v-if="edit">
              <a v-if="$store.getters.isFormSubmittable && !deleting" @click="deleteButtonClick()" href="javascript:;" class="button primary submit large" style="background-color: darkred;">Slett</a>
              <a v-else-if="deleting" href="javascript:;" class="button primary submit large loading">Slett <span class="loader-spinner"></span></a>
              <a v-else href="javascript:;" class="button primary submit large" disabled>Slett</a>
            </template> -->
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import MiscService from '@/services/MiscService'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'

export default {
  name: 'LabelModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      form: {},
      warn: false,
      labelTypeOptions: [],
      parentOptions: [],
      kategoriOptions: [],
      deleting: false
    }
  },
  computed: {
    parentOptionsTree: function () {
      let retval = []

      this.parentOptions.forEach((item) => {
        if (item.labeltype === 'V') {
          let temp = {}
          temp.id = item.key
          temp.label = item.val

          // Add children
          if (item.children && item.children.length > 0) {
            temp.children = []
            this._appendChildren(temp.children, item.children)
          }

          retval.push(temp)
        }
      })

      return retval
    }
  },
  watch: {
    'form.labeltype': function (newVal) {
      if (newVal === 'V') {
        this.$set(this.form, 'Kategori', null)
      } else if (newVal === 'K') {
        this.$set(this.form, 'Parent', null)
      }
    }
  },
  created () {
    this.edit = this.item && this.item.Labelid

    if (this.edit) {
      this.form = this._.cloneDeep(this.item)
    } else {
      this.$set(this.form, 'labeltype', this.type)
    }

    this.fetch()
  },
  methods: {
    fetch: function () {
      this.setFormLoading(true)
      this.labelTypeOptions.unshift({key: this.form.labeltype || null, val: 'Laster...'})
      this.kategoriOptions.unshift({key: this.form.Kategori || null, val: 'Laster...'})

      InstillingerService('labeltype').dropdown()
        .then((response) => {
          console.log('Got response', response)
          this.labelTypeOptions = response.data
          this.labelTypeOptions.unshift({key: '', val: 'Velg type', disabled: true})
        })
        .catch(error => {
          console.log('Error fetching')
          console.log(error)
        })
        .then(() => {
          this.setFormLoading(false)
        })

      MiscService.loadDropdownLabels()
        .then((data) => {
          this.parentOptions = data.tree
        })

      // Load kategori dropdown
      MiscService.loadDropdownKategori()
        .then((data) => {
          this.kategoriOptions = data
          this.kategoriOptions.unshift({key: null, val: 'Alle kategorier'})
        })
    },
    deleteButtonClick: function () {
      console.log('Delete me')
      const vm = this
      const labelName = this.form.Navn
      this.openConfirm(
        `Er du sikker på at du ønsker å slette "${labelName}"?`,
        'Denne handlingen kan ikke angres.',
        'Ja',
        'Nei',
        function () {
          vm.handleDelete()
          vm.closeModal()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    closeButtonClick: function () {
      this.closeModal()
    },
    handleDelete: function () {
      this.deleting = true

      InstillingerService('label').delete(this.form.Labelid)
        .then(response => {
          console.log('Ok', response)

          this.closeModal()
          bus.$emit('label-deleted', this.item)
        })
        .catch((error) => {
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
        })
        .then(() => {
          this.deleting = false
        })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.save()
          }
        })
    },
    save: function () {
      this.setFormProcessing(true)

      const post = this._.omit(this.form, ['Dato', 'parent'])
      if (post.Parent === undefined) {
        post.Parent = null
      }

      console.log(post)

      InstillingerService('label').save(this.form.Labelid, post)
        .then((response) => {
          this.$helpers.showSuccessAlert('Label er lagret')

          this.closeModal()
          bus.$emit('label-saved', response.data)
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
          }
        })
        .then(() => {
          this.setFormProcessing(false)
        })
    },
    _appendChildren: function (retval, array) {
      // Append children for the tree multi select
      array.forEach((item) => {
        let temp = {}
        temp.id = item.key
        temp.label = item.val

        // Add children?
        if (item.children && item.children.length > 0) {
          temp.children = []

          this._appendChildren(temp.children, item.children)
        }

        retval.push(temp)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/Label/LabelModal.vue